const maxNameLenght = 2000

export {maxNameLenght}